import styled from 'styled-components';
import { Link as LinkR } from 'react-router-dom';

export const PressContainer = styled.div`
    background: #d3d3d3;
    position: relative;
    height: 90vh;
    overflow: hidden;
    padding-top: 100px;

    @media screen and (min-height: 1200px) {
        height: 90vh;
    }

    @media screen and (max-height: 1060px) {
        height: 130vh;
    }

    @media screen and (max-height: 820px) {
        height: 200vh;
    }

    @media screen and (max-height: 530px) {
        height: 270vh;
    }

    @media screen and (max-height: 395px) {
        height: 400vh;
    }

    @media screen and (max-width: 480px) {
        height: 270vh;
        padding-bottom: 8rem;
    }
`

export const TitleWrapper = styled.div`
    width: 100%;
    max-width: 300px;
    margin: 0 auto;
    margin-top: 3rem;
    margin-bottom: 2rem;
    text-align: center;
    padding-bottom: 1rem;
    border-bottom: 2px solid black;

    @media screen and (max-width: 480px) {
		max-width: 270px;
	}

    @media screen and (max-width: 370px) {
        max-width: 200px;
        margin-top: 2rem;
    }
`

export const Title = styled.h1`
    font-size: 2.3rem;
    font-weight: bold;

    @media screen and (max-width: 480px) {
		font-size: 1.8rem;
		text-align: center;
	}

    @media screen and (max-width: 370px) {
        font-size: 1.5rem;
    }
`

export const PressWrapper = styled.div`
    position: relative;
    margin: 0 auto;
    padding: 0 24px;
    height: 100%;
    max-width: 1400px;
    align-items: center;
`

export const ReleaseWrapper = styled.div`
    display: block;
    padding-bottom: 3.5rem;

`

export const Header = styled.h1`
    font-size: 24px;
    font-weight: bold;
    color: #000000;
    padding-bottom: .5rem;

    @media screen and (max-width: 480px) {
		font-size: 1.3rem;
        padding-bottom: 1rem;
	}

    @media screen and (max-width: 370px) {
        font-size: 1rem;
    }
`

export const Date = styled.h2`
    font-size: 24px;
    color: #000000;
    padding-bottom: 1rem;
`

export const Subheader = styled.h3`
    font-size: 18px;
    color: #000000;

    @media screen and (max-width: 480px) {
		font-size: 1rem;
	}

    @media screen and (max-width: 370px) {
        font-size: .8rem;
    }
`

export const Button = styled(LinkR)`
    font-size: 18px;
    color: #2f8eed;
    text-decoration: none;
    transition: all 0.2s ease-in-out;

    &:hover {
        color: #000000;
        transition: all 0.3s ease-in-out;
    }

    @media screen and (max-width: 480px) {
		font-size: 1rem;
	}

    @media screen and (max-width: 370px) {
        font-size: .8rem;
    }
`